import axios from "../../axios";

const getContactGroupById = async (id) => {
  try {
    const { data } = await axios.get(`/contact_groups/${id}`);
    return data;
  } catch (error) {
    return null;
  }
}

const getContactList = async (id) => {
  try {
    const { data } = await axios.get(`/contact_groups/${id}/contacts`);
    return data;
  } catch (error) {
    return [];
  }
}

export { getContactGroupById, getContactList };